import React from "react";
import { Button, Col, Row, Form } from "react-bootstrap";

import { FsDatetime, FsText, FsSelect } from "shared/components/fs";

export default class CompanyForm extends React.PureComponent {
  render() {
    const { props } = this;
    const { formState } = props;
    if (!formState) {
      return null;
    }

    return (
      <Form horizontal>
        <h2>Was machst Du?</h2>

        <FsText
          formState={formState}
          attribute="name"
          label="Firmenname"
          placeholder="Musterfood GmbH"
        />

        <FsText
          formState={formState}
          attribute="main_product_name"
          label="Name Deines Produktes"
          placeholder="Musterfood Crispy Chips"
        />

        <FsSelect
          formState={formState}
          attribute="main_product_category"
          label="Warengruppe"
          options={this.props.allProductCategories}
          emptyOption="Bitte auswählen"
        />

        <FsDatetime
          formState={formState}
          attribute="founding_date"
          label="Gründungsjahr und -monat Deiner Firma"
          placeholder="01.2015"
          dateFormat="MM.YYYY"
        />

        <FsSelect
          formState={formState}
          attribute="last_year_gross_revenue"
          label="Bruttoumsatz im letzten Jahr"
          options={[
            "Unter 10 TEUR",
            "10 TEUR bis 100 TEUR",
            "100 TEUR bis 1000 TEUR",
            "1000 TEUR bis 5000 TEUR",
            "Über 5000 TEUR",
          ]}
          emptyOption="Bitte auswählen"
        />

        <FsSelect
          formState={formState}
          attribute="edeka_store_count"
          label="Anzahl EDEKA Märkte mit Deinem Produkt"
          options={[
            "Kein EDEKA Markt",
            "Unter 50 EDEKA Märkte",
            "50 bis 100 EDEKA Märkte",
            "100 bis 500 EDEKA Märkte",
            "500 bis 1000 EDEKA Märkte",
            "Über 1000 EDEKA Märkte",
          ]}
          emptyOption="Bitte auswählen"
        />

        <Row>
          <Col sm={3} smOffset={4}>
            <Button className="btn btn-secondary" onClick={props.cancelFn}>
              Zurück
            </Button>
          </Col>
          <Col sm={3}>
            <Button
              type="submit"
              className="btn btn-secondary"
              onClick={props.submitFn}
            >
              Weiter
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}
